<app-page-title [title]="'NOTIFICATIONS.NOTIFICATIONS' | translate"></app-page-title>

<div class="row row-content">
    <div class="col col-12 col-sm-6 col-md-3 notification-list mt-1">
        <div class="bg-white">
            <div class="search">
                <div class="searchbar">
                    <input style="height: 27px;" [(ngModel)]="search" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="filter()" type="text" class="form-control"
                        [placeholder]="'SEARCH' | translate" />
                    <i class="fa fa-search search-btn" aria-hidden="true"></i>
                </div>
            </div>

            <div class="d-flex btn-divs">
                <button (click)="tabIndex === 1 ? clickButton(0) : null" type="button" class="btn w-50"
                    [ngClass]="{'btn-secondary': tabIndex === 1, 'btn-primary': tabIndex === 0 }">{{'NOTIFICATIONS.ALL'|translate}}</button>
                <div class="me-1 ms-1"></div>
                <button (click)="tabIndex === 0 ? clickButton(1) : null" type="button" class="btn w-50"
                    [ngClass]="{'btn-secondary': tabIndex === 0, 'btn-primary': tabIndex === 1 }">{{'NOTIFICATIONS.NOTREAD'|translate}}
                </button>
            </div>

            <app-ui-preloader id="spinner" [display]="loading" [size]="'50px'"></app-ui-preloader>

            <div *ngIf="!loading" class="scroll mt-1" infinite-scroll [scrollWindow]="false" (scrolled)="loadMore()">
                <div *ngFor="let item of notifications" class="notification" (click)="select(item)"
                    [ngClass]="{'message-active':selectedNotification?.id === item.id,'message-notRead':item.read ==false}">
                    <div class="desc-contact">
                        <p [ngClass]="{'bold':item.read ==false}" class="name">{{item.subject}}</p>
                        <p [ngClass]="{'bold':item.read ==false}" class="message">{{item.message}}</p>
                    </div>
                    <div class="timer">{{item.createdAt | date: 'YYYY-MM-dd' }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="col col-12 col-sm-6 col-md-9 mt-1" *ngIf="selectedNotification">
        <div class="card notification-detail">
            <div class="notification-header">
                <h4>{{selectedNotification.subject}}</h4>
            </div>
            <div class="card-body">
                <p-editor [readonly]="true" [(ngModel)]="selectedNotification.html" [disabled]="true">
                    <p-header hidden>
                        <span class="ql-formats"></span>
                    </p-header>
                </p-editor>
            </div>
        </div>
    </div>
</div>